import { gql } from '@apollo/client';

export interface ToggleEventRequestQuoteLimited {
  toggleEventRequestQuoteLimiting: {
    uuid: string;
    id: string;
  };
}

export const TOGGLE_EVENT_REQUEST_QUOTE_LIMITED = gql`
  mutation($requestId: String!, $quoteLimited: Boolean!) {
    toggleEventRequestQuoteLimiting(
      requestId: $requestId
      quoteLimited: $quoteLimited
    ) {
      uuid
      id
    }
  }
`;
